import { cn } from '@/lib/utils';

/**
 * Branded loading indicator — the real Ashlar mark (flat two-tone, no gradient),
 * breathing gently. Use for page/section-level loading
 * screens in the Ashlar app. Do NOT use on appraiser member sites (those
 * carry the appraiser's branding, not ours), inside buttons, or where a
 * skeleton fits better — skeletons stay.
 */
export function BrandLoader({
  size = 48,
  label,
  className,
}: {
  size?: number;
  label?: string;
  className?: string;
}) {
  return (
    <div role="status" aria-live="polite" className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <div className="brand-loader-breathe">
        <img src="/ashlarapp-logo.svg" width={size} height={size} alt="" className="block" />
      </div>
      {label ? (
        <p className="text-sm text-muted-foreground">{label}</p>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </div>
  );
}

/** Full-height variant for route transitions and whole-page loading states. */
export function PageLoader({ label, className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex min-h-screen items-center justify-center', className)}>
      <BrandLoader size={56} label={label} />
    </div>
  );
}

/** Section-height variant for in-page content areas (dashboards, tabs, lists). */
export function SectionLoader({ label, className }: { label?: string; className?: string }) {
  return (
    <div className={cn('flex h-96 items-center justify-center', className)}>
      <BrandLoader size={44} label={label} />
    </div>
  );
}
